import React from "react";
import { useTranslation } from "react-i18next";
import { openReportProblem } from "./reportProblemBus";
import tailwindClassnames from "./TailwindClassnames";

// Define the type for the props of the component, even if it currently has no props
type UnexpectedErrorProps = {};

const UnexpectedError: React.FC<UnexpectedErrorProps> = (props) => {
  const { t } = useTranslation();

  async function navigate() {
    window.location.href = "/";
  }

  // Note the comment about making revisions to both this and another component.
  // `UnauthorizedComponent` renders the same three-paragraph-plus-Okay layout and still uses
  // the pre-refresh `saveButton`. It is deliberately left alone by AKL-798: a signed-out user
  // cannot post a report, so it gains no entry point, and its copy lives behind three opaque
  // keys (`UnauthorizedPart1/2/3`) whose retranslation is a wording review of its own.
  return (
    <div className="flex justify-center h-screen">
      <div className="mt-6 mx-2">
        <div>
          <p className={tailwindClassnames.warningHeader}>
            {t("There has been an unexpected error. Please, try again.")}
          </p>
          <p className={`mt-6 ${tailwindClassnames.basicLabel}`}>
            {t(
              "If the issue persists, make sure you have an internet connection and logout/login.",
            )}
          </p>
          <p className={tailwindClassnames.basicLabel}>
            {t(
              "If you continue to have issues, please contact your system administrator.",
            )}
          </p>
          <div className="bg-dustyGray-300 dark:bg-dustyGray-800 text-right mt-2 flex justify-end gap-2.5">
            {/* The failed request this report carries is NOT passed from here — the 5xx
                branch of the interceptor reaches this page by a full document navigation, so
                it was written to sessionStorage before navigating and the host reads it back
                (see lastFailedRequest.ts). */}
            <button
              type="button"
              className={tailwindClassnames.btnSecondary}
              onClick={() => openReportProblem("unexpectedError")}
              data-testid="unexpected-error-report"
            >
              {t("Report this problem")}
            </button>
            {/* Was type="submit" with the pre-refresh `saveButton`: it is not in a form, and
                `submit` was a latent surprise. The handler is unchanged. */}
            <button
              type="button"
              className={tailwindClassnames.btnPrimary}
              onClick={navigate}
            >
              {t("Okay")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnexpectedError;
